import Counter from "./Counter.js";
export default Counter;
